import React, { Suspense, lazy } from "react"
import WidgetErrorFallback from "./WidgetErrorFallback"
import ErrorBoundary from "../../pages/error/ErrorBoundary"

const Chart = lazy(() => import("./chart/Chart"))

/**
 * Simple wrapper to split Highchart usage in app.
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export default function LazyChart(props) {
  return (
    <Suspense fallback={null}>
      <ErrorBoundary type="Chart" FallbackComponent={WidgetErrorFallback}>
        <Chart {...props} />
      </ErrorBoundary>
    </Suspense>
  )
}
